module.exports = __webpack_public_path__ + "img/arms-of-bennett-memorial.44d0b744.jpg";